import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { GridArea } from 'src/shared/constants';

import { MAIN_CONTENT_ID } from '../SkipLink';

interface MainProps {
  children: ReactNode;
}

const Container = styled.main`
  display: grid;
  grid-area: ${GridArea.MAIN};
`;

const Main = ({ children }: MainProps) => (
  <Container id={MAIN_CONTENT_ID}>{children}</Container>
);

export { Main };
